import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/axios'
import { API_ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/stores/useAuthStore'

export interface DocumentType {
    id: number
    name: string
    slug: string
    default_width_mm: number
    default_height_mm: number
    description: string
    icon: string
    is_active: boolean
}

const KEYS = {
    all: ['document-types'] as const,
    list: () => [...KEYS.all, 'list'] as const,
}

interface PaginatedResponse<T> {
    count: number
    next: string | null
    previous: string | null
    results: T[]
}

export function useDocumentTypes() {
    const { isLogged } = useAuthStore()
    return useQuery({
        queryKey: KEYS.list(),
        queryFn: async () => {
            const { data } = await api.get<PaginatedResponse<DocumentType> | DocumentType[]>(API_ROUTES.documentTypes)
            // Handle both paginated and plain array responses
            if (Array.isArray(data)) return data
            return data.results
        },
        enabled: isLogged,
        staleTime: 5 * 60 * 1000,
    })
}
